module.exports = __webpack_public_path__ + "img/edit-pen.620ca4c1.svg";